function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Data = function Data(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M14.21 1c.814 0 1.583.304 2.165.854l4.474 4.236v.001c.593.56.932 1.343.932 2.145V20c0 1.654-1.452 3-3.237 3H6.238C4.453 23 3 21.654 3 20V4c0-1.654 1.453-3 3.238-3zm0 2H6.238C5.555 3 5 3.448 5 4v16c0 .552.555 1 1.238 1h12.306c.682 0 1.237-.448 1.237-1V8.236a.95.95 0 0 0-.307-.693L15 3.308A1.15 1.15 0 0 0 14.21 3m-4.195 7.225q.68 0 1.252.164.571.164 1.004.563l-.88.96a1.75 1.75 0 0 0-.576-.4q-.32-.135-.8-.136-.4 0-.724.137a1.61 1.61 0 0 0-.912.96 2.1 2.1 0 0 0-.124.727q-.001.4.124.733.123.331.356.575.232.245.556.38.324.136.724.137a2.43 2.43 0 0 0 1.176-.281v-.92h-1.016v-1.152h2.216v2.96a4.5 4.5 0 0 1-1.152.416q-.6.128-1.224.128a3.5 3.5 0 0 1-1.224-.208 2.8 2.8 0 0 1-.968-.596 2.7 2.7 0 0 1-.636-.94 3.2 3.2 0 0 1-.228-1.232 3.2 3.2 0 0 1 .228-1.232q.228-.551.636-.94.407-.388.968-.595a3.5 3.5 0 0 1 1.224-.208m5.584.144q.368 0 .74.05.372.055.668.209.295.157.48.437.184.279.184.744 0 .479-.268.796a1.5 1.5 0 0 1-.708.452v.016q.28.04.508.156t.392.296.252.42.088.51q0 .45-.192.75a1.5 1.5 0 0 1-.496.484 2.2 2.2 0 0 1-.684.264q-.381.08-.756.08h-2.32v-5.664zm.08 3.32h-.944v1.288h1.12q.144 0 .292-.032a.8.8 0 0 0 .268-.113.602.602 0 0 0 .272-.519.5.5 0 0 0-.1-.324.64.64 0 0 0-.252-.19 1.4 1.4 0 0 0-.328-.087 3 3 0 0 0-.328-.023m-.096-2.265h-.848v1.208h.904q.144 0 .284-.031a.8.8 0 0 0 .252-.104.55.55 0 0 0 .18-.192.6.6 0 0 0 .068-.288.5.5 0 0 0-.076-.292.54.54 0 0 0-.196-.181 1 1 0 0 0-.272-.091 1.6 1.6 0 0 0-.296-.03"
  }));
};
export default Data;